import React from "react";
import ReactDOM from "react-dom";
import "./styling/main.scss";
import App from "./containers/App";
import * as serviceWorker from "./serviceWorker";
import { json } from "d3";
import "./styling/fonts.scss";

import { NestedData, Question } from "./global-interfaces";
import { SECTION_MAPPING } from "./constants";

/**
 * helper function that nests the data by section and card
 * @param data
 * @returns array of questions rolled up to card and section
 */
const structureData = (data: Question[]): NestedData[] => {
  /** groups by section */
  const reduced = data.reduce((acc: any, curr: Question) => {
    if (!acc[curr.section]) {
      const section = SECTION_MAPPING.find(d => d.title === curr.section);
      acc[curr.section] = { ...section, cards: [] };
    }
    acc[curr.section].cards = [...acc[curr.section].cards, curr];
    return acc;
  }, {});

  /** go through each section and group by cards */
  for (const section in reduced) {
    const groupedCards = reduced[section].cards.reduce(
      (acc: any, curr: any) => {
        if (!acc[curr.card]) {
          acc[curr.card] = { card: curr.card, questions: [] };
        }
        acc[curr.card].questions = [...acc[curr.card].questions, curr];
        return acc;
      },
      {}
    );
    reduced[section].cards = Object.values(groupedCards);
  }

  return (Object.values(reduced) as NestedData[]).sort(
    (a, b) => a.index - b.index
  );
};

json(process.env.PUBLIC_URL + "/data/data.json").then(data => {
  ReactDOM.render(
    <App data={structureData(data as Question[])} />,
    document.getElementById("root")
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
